import React from "react";
import { Map } from "immutable";
import PropTypes from "prop-types";
import classNames from "classnames";

import AuthorizedOwner from "MODULES/shared/components/AuthorizedOwner";
import AuditFields from "../AuditFields/AuditFields";
/* eslint react/no-danger: 0 */
export default class Note extends React.Component {
  static propTypes = {
    additionalActions: PropTypes.arrayOf(PropTypes.shape({})),
    note: PropTypes.instanceOf(Map).isRequired,
    onViewNote: PropTypes.func.isRequired,
    onEditNote: PropTypes.func.isRequired,
    onDeleteNote: PropTypes.func.isRequired,
    toggleAction: PropTypes.func.isRequired
  };

  state = {
    expanded: false
  };

  componentWillUnmount() {
    this.closeDropdown();
  }

  addListener() {
    document.addEventListener("click", this.closeDropdown);
  }

  removeListener() {
    document.removeEventListener("click", this.closeDropdown);
  }

  openDropdown = () => {
    this.addListener();
    this.setState({ expanded: true });
  };

  closeDropdown = () => {
    this.removeListener();
    this.setState({ expanded: false });
  };

  render() {
    const {
      additionalActions,
      note,
      onViewNote,
      onEditNote,
      onDeleteNote,
      toggleAction
    } = this.props;
    const { expanded } = this.state;
    const buttonClasses = classNames("btn-group", { open: expanded });

    return (
      <div
        className="panel panel-default panel-note"
        style={{ marginBottom: 2 }}
      >
        <div
          className="panel-heading"
          role="tab"
          id="headingOne"
          style={{ padding: "8px 15px" }}
        >
          <div className="pull-right">
            <div className={buttonClasses} onClick={this.openDropdown}>
              <button
                type="button"
                className="btn btn-default btn-hollow dropdown-toggle"
              >
                <i className="fa fa-fw fa-chevron-down" />
              </button>
              <ul className="dropdown-menu dropdown-menu-right">
                <li
                  style={{ cursor: "Pointer" }}
                  onClick={() => onViewNote(note)}
                >
                  <a>
                    <i className="fa fa-fw fa-eye" />
                    &nbsp;View
                  </a>
                </li>
                {note.get("important") && (
                  <li
                    style={{ cursor: "Pointer" }}
                    onClick={() => onEditNote(note)}
                  >
                    <a>
                      <i className="fa fa-fw fa-pencil" />
                      &nbsp;Edit
                    </a>
                  </li>
                )}
                <AuthorizedOwner record={note}>
                  {!note.get("important") && (
                    <li
                      style={{ cursor: "Pointer" }}
                      onClick={() => onEditNote(note)}
                    >
                      <a>
                        <i className="fa fa-fw fa-pencil" />
                        &nbsp;Edit
                      </a>
                    </li>
                  )}
                  <li
                    style={{ cursor: "Pointer" }}
                    onClick={() => onDeleteNote(note)}
                  >
                    <a>
                      <i className="fa fa-fw fa-close" />
                      &nbsp;Delete
                    </a>
                  </li>
                </AuthorizedOwner>
                {additionalActions &&
                  additionalActions.map(action => (
                    <li
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        toggleAction(note, action.key);
                      }}
                    >
                      <a>
                        <i className="fa fa-fw fa-pencil" />
                        &nbsp;{action.label}
                      </a>
                    </li>
                  ))}
              </ul>
            </div>
          </div>
          <AuditFields record={note} />
        </div>
        <div
          id="collapseOne"
          className="panel-collapse collapse in"
          role="tabpanel"
          aria-labelledby="headingOne"
        >
          <div className="panel-body" style={{ padding: "8px 15px" }}>
            <span
              dangerouslySetInnerHTML={{
                __html: note.get("body").replace(/\n/g, "<br />")
              }}
            />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/modules/shared/components/Notes/Note.jsx